import { getApi } from 'common/api-common'
import { blobbyStrings } from './strings'
import { Constants } from 'common/utils'

const defaultStrings = {
  byTube: 'Getting here by Tube',
  byTubeDescription: "We're easy to find.",
  contactInstructions: `You can click the live-chat icon, or contact us on:<br/><a class="color-pink2 text-decoration-none" href="tel:${Constants.companyInformation.phone_full}">${Constants.companyInformation.phone_full}</a> or <br class="d-sm-none"/><a class="text-decoration-none" href="mailto:${Constants.companyInformation.email}">${Constants.companyInformation.email}</a>,<br class="d-sm-none"/> or follow us on X at <a class="text-decoration-none" href="${Constants.companyInformation.twitter}">${Constants.companyInformation.twitter_handle}</a>.`,
  contactInstructionsAu: `You can click the live-chat icon, or contact us on:<br/><a class="color-pink2 text-decoration-none" href="tel:${Constants.companyInformation.phoneAu.replace(
    /\s/g,
    '',
  )}">${
    Constants.companyInformation.phoneAu
  }</a> or <br class="d-sm-none"/><a class="text-decoration-none" href="mailto:${
    Constants.companyInformation.emailAu
  }">${
    Constants.companyInformation.emailAu
  }</a>,<br class="d-sm-none"/> or follow us on X at <a class="text-decoration-none" href="${
    Constants.companyInformation.twitter
  }">${Constants.companyInformation.twitter_handle}</a>.`,
  fromLiverpoolStreet: 'From Liverpool Street station',
  fromLiverpoolStreetDescription:
    'From the concourse, follow signs to Broadgate, walk anti-clockwise around Broadgate Circle, then take the first left towards Finsbury Avenue. Turn left onto Sun Street and continue to Wilson Street. Turn right and carry straight ahead. Wilson Street becomes Paul Street. Continue along Paul Street — <strong>The Hoxton Mix (66 Paul Street, London EC2A 4NA)</strong> is on the right-hand side.',
  fromOldStreet: 'From Old Street tube station',
  fromOldStreetDescription:
    'The Hoxton Mix is a five-minute walk (about 300 metres) from Old Street Tube Station. Please use the Cowper Street exit. From the station, walk down Cowper Street, turn left and then follow the road around to Paul street. <strong>The Hoxton Mix (66 Paul Street, London EC2A 4NA)</strong> is a short way along on the left-hand side.',
  seoContactUsDescription:
    'Contact The Hoxton Mix: Use live chat, phone us or send an email to contact us.',
  seoContactUsTitle: 'How To Contact Us | Hoxton Mix',
  wedLoveToHearFromYou:
    "We'd love to hear from you — please feel free to contact us below.",
  wedLoveToHearFromYouDescription: 'Want to sign up or have a question for us?',
}
export const contactUsStrings = getApi().makeStrings({
  en: defaultStrings,
  es: blobbyStrings(defaultStrings),
})
